import { DataGridPremiumProps, GridColDef, GridColumnVisibilityModel } from "@mui/x-data-grid-premium"
import { PAGING } from "../components/constant/constant"
import { AppDispatch } from "../store/store"
import { ResponseArray } from "../common/common.entity"
import { IFormBuilder } from "../components/formBuilder/formBuilder.entity"
import { APICallFunction } from "../pages/userMangement/role/apiCall"

export interface ICatalogBuilder {
  headerLabel?: string
  headerOnAddPath?: any
  headerButtonLabel?: string

  pagingMethod?: string
  pagingAPI?: string
  pagingAPIKey?: string
  pagingAPIReducer?: any
  pagingAPIrequest?: any
  pagingAPILoader?: any
  customPagingValue?: any
  pagingAPIparam?: any
  getPagingData: (dispatch: AppDispatch, ...params: any) => any
  onDelete?: (dispatch: AppDispatch, ...params: any) => any

  pagingColumns?: GridColDef[]
  getRowIdByPaging?: string
  onEditPath?: string
  isHeader?: boolean
  isAssociationButton?: boolean
  onClickPlus?: (data?: any, mode?: IFormBuilder['mode']) => void
  isRightMenu?: boolean
  onviewPath?: string
  onModeClickPath?: string

  isMenuItem?: boolean
  menuItemsArray?: any
  onMenuClick?: any
  associationPagingHeader?: string
  isRefreshButton?: boolean
  handleOnEdit?: any
  isNestedDrawer?: any
  isDefaultActionButton?: boolean
  orgTypeGroupId?: any

  deletePagingAPI?: any
  deletePagingAPIKey?: string
  deletePagingAPIReducer?: any
  deletePagingAPILoader?: any
  isHeaderButton?: boolean
  isFooterButton?: boolean
  isViewMode?: boolean
  isPlusButton?: boolean
  isEditMode?: boolean

  pagingRefeshAPI?: any
  pagingRefreshMethod?: any
  pagingRefeshAPIrequest?: any
  pagingOnTabClickPaging?: boolean

  footerButtonLabel?: string
  hideFooterSelectedRowCount?: boolean
  hideFooterPagination?: boolean

  border?: any
  pageSizeOptions?: Array<number | {
    value: number;
    label: string;
  }>
  autoPageSize?: any,
  mode?: IFormBuilder['mode'],
  disableEditAction?: boolean,
  disableDeleteAction?: boolean,
  disableViewAction?: boolean,

  dataGridProps?: Partial<DataGridPremiumProps>
  getTreeData?: APICallFunction
  treeApiKey?: string
  treeData?: ResponseArray
  treeViewLabel?: string
  visibleColumns?: GridColumnVisibilityModel
}

export const defaultState = {
  skip: 0,
  take: PAGING?.take,
};

export const MethodTypes = {
  Get: "Get",
  Post: "Post",
};